const PbxxRecord = require('../pbxx_record')

module.exports = class ContentDiscoveryItem extends PbxxRecord {
  static get class_name() {
    return 'ContentDiscoveryItem'
  }
}
